
import {DutchAdjective, DutchAdjectiveResources} from "../types";
import {StyledTable} from "../../../../../common/components/StyledTable";
import {getAudioForSource} from "../../../../../common/utils/audioUtils";
import {GeneralWordResources} from "../../../../../common/types/words";
import {Box} from "@mui/material";

export interface DutchAdjectiveConjugationViewProps {
    adjectiveMorphology: DutchAdjective;
    adjectiveResources: GeneralWordResources<DutchAdjectiveResources> | null;
}


export function DutchAdjectiveConjugationView({adjectiveMorphology, adjectiveResources}: DutchAdjectiveConjugationViewProps) {

    const handleCellClicked = (row: { resource: string | null | undefined }, cellIndex: number) => {
        if (cellIndex !== 1) return;
        getAudioForSource(row.resource)?.play();
    };

    return (
        <Box mt={1}>
            <StyledTable
                columns={[
                    {key: "key", render: (row) => row.field, clickable: false},
                    {key: "value", render: (row) => row.value},
                ]}
                rows={[
                    {field: "Inflected form", value: adjectiveMorphology.inflectedForm, resource: adjectiveResources?.inflectedForm},
                    {field: "Comparative", value: adjectiveMorphology.comparative, resource: adjectiveResources?.comparative},
                    {field: "Superlative", value: adjectiveMorphology.superlative, resource: adjectiveResources?.superlative},
                ]}
                getRowKey={(_row, index) => index}
                showHeader={false}
                onCellClicked={handleCellClicked}
            />
        </Box>
    )


}
